import React from "react";
import moment from "moment";
import {Tag} from 'antd'

import typo from "../../../constants/dictionaries";
import helper from '../../../helper/helper'
// Colors

const Status = ({ value, trangthai, thoiGian } = {}) => {
  if (trangthai === 1) {
    return <Tag color="red">{typo.cscore_expired}</Tag>
  }
   else if (trangthai === 7) {
    return <Tag color="volcano">Hết hiệu lực(Có GP thay thế)</Tag>
  }
  else {
    const validateDate = (date) => {
      const now = moment();
      const convertDate = moment(date);
      const before_days = helper.subtractDate(convertDate, thoiGian ? thoiGian : 120);
      if (helper.compareDate(now, convertDate)) {
        return 'red'
      } else {
        if (helper.compareDate(now, before_days)) {
          return 'gold'
        } else {
          return 'green'
        }
      }
    };

    return <Tag color={validateDate(value)}>{validateDate(value) === 'red' ? typo.cscore_expired : validateDate(value) === 'gold' ? typo.cscore_expiringSoon : typo.cscore_validated}</Tag>
  }
};

export default Status;
